import { render } from "./CardEditor.vue?vue&type=template&id=6e10bbe1&scoped=true"
import script from "./CardEditor.vue?vue&type=script&lang=js"
export * from "./CardEditor.vue?vue&type=script&lang=js"

import "./CardEditor.vue?vue&type=style&index=0&id=6e10bbe1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e10bbe1"]])

export default __exports__